import aponeo from './aponeo';
import { showLoadingScreen } from './loadingScreen';

export default function () {
  /**
   * Packstation finder for customer addresses
   */
  (function ($) {
    /** @class Finder */
    function Finder(form, result, resultContainer, action, trigger, modal) {
      this.form = form;
      this.result = result;
      this.resultContainer = resultContainer;
      this.ajax_action = action;
      this.dialog = modal;
      this.busy = false;

      //Search-Button Text for wording changes through the process
      this.buttonText = $('button', this.resultContainer).text();
      this.buttonLastWord = this.buttonText.split(' ').pop();
      this.lastIndex = this.buttonText.lastIndexOf(' ');
      this.buttonFirstWords = this.buttonText.substring(0, this.lastIndex);

      const self = this;
      form.on('submit', function () {
        self.search();
        self.dialog.one('hidden.bs.modal', function () {
          self.loadScreen(true);
        });
        $('button', self.resultContainer).html(self.buttonFirstWords + ' ' + self.buttonLastWord);
        return false;
      });
      result.on('click', 'label', function (event) {
        if (!self.result.data('selected')) {
          const elem = $('#' + this.htmlFor);
          const parent = elem.parent();
          /** todo refactor the AJAX result instead */
          // hide all immediate children of the container, but not the parent of the input and the next two elements
          $('> *', self.result).not(parent).not(parent.nextAll(':lt(2)')).hide();
          $(parent.nextAll(':lt(1)')).addClass('dhl-choice');
          // console.log($('button', self.resultContainer));
          // $('button', self.resultContainer).html(self.buttonFirstWords + ' ändernX');
          // $('button', self.resultContainer).removeClass('btn-primary');
          // $('button', self.resultContainer).addClass('btn-secondary');

          self.result.data('selected', true);
          aponeo.scrollTop(self.result);
        } else {
          $('> *', self.result).show();
          self.result.data('selected', false);
        }
      });
      if (trigger) {
        trigger.one('show.bs.collapse', function () {
          self.search();
        });
      }
    }

    Finder.prototype = {
      search: function () {
        const form = this.form[0];
        const street = form.street.value;
        const houseNumberMatch = form.house_number.value.match(/[0-9]+/);
        const house_number = (houseNumberMatch && houseNumberMatch[0]) || 1; // the first element or a 1
        const post_code = form.postal_code.value;
        const city = form.city.value;
        const packstation = form.packstation.value;
        // only query if there is data
        if (street && house_number && post_code && city) {
          /** todo load screen */
          this.setIsBusy(true);
          this.dialog.modal('hide');
          const self = this;
          this._query(street, house_number, post_code, city, packstation)
            .always(function () {
              self.result.data('selected', false);
              self.resultContainer.show();
              self.busy = false;
              self.setIsBusy(false);
              self.loadScreen(false);
            })
            .fail(function () {
              self.result.html('<p>Es ist ein Fehler aufgetreten, bitte probieren Sie es später noch einmal.</p>');
            });
        }
        return null;
      },
      _query: function (street, house_number, post_code, city, current_packstation_id) {
        const self = this;
        const payload = [street, house_number, post_code, city].join('::');
        return $.ajax({
          url: '/rpc.php',
          data: {
            action: this.ajax_action,
            id: payload,
            street: street,
            zip: post_code,
            city: city,
            option: current_packstation_id,
          },
        }).done(function (response) {
          $('button', self.resultContainer).html(self.buttonFirstWords + ' ändern');
          $('button', self.resultContainer).removeClass('btn-primary');
          $('button', self.resultContainer).addClass('btn-secondary');
          console.log('AA##################################');
          console.log(street);
          console.log(response);
          console.log('AAA##################################');
          self.result.empty();
          // const update = response.split('|');
          // try {
          //   self.result.html(update[1]);
          // } catch (ex) {
          //   if (_debug) console.log(
          //       'Packstation finder error: unreadable response', ex, response);
          // }

          try {
            self.result.html(response.html);
          } catch (ex) {
            if (_debug) console.log('Packstation finder error: unreadable response', ex, response);
          }
        });
      },
      setIsBusy: function (state) {
        this.busy = true;
        return this;
      },
      loadScreen: function (show) {
        if (show) {
          showLoadingScreen();
        } else {
          $('body').removeClass('loading');
        }
      },
    };
    /** factory function for packstationfinder
     *
     * @function Finder.packstation
     * @returns {Finder}
     */
    Finder.packstation = function () {
      return new Finder(
        $('#packstationfinder'),
        $('#ps_suche'),
        $('#packstation-result'),
        'ps_suche',
        $('#neue-packstation'),
        $('#packstationfinder-modal'),
      );
    };
    /** factory function for postfilialfinder
     *
     * @function Finder.postfiliale
     * @returns {Finder}
     */
    Finder.postfiliale = function () {
      return new Finder(
        $('#postfilialefinder'),
        $('#pf_suche'),
        $('#postfiliale-result'),
        'pf_suche',
        $('#neue-postfiliale'),
        $('#postfilialefinder-modal'),
      );
    };
    Finder.hermespaketshop = function () {
      return new Finder(
        $('#hpsfinder'),
        $('#hps_suche'),
        $('#hps-result'),
        'hps_suche',
        $('#neuer-paketshop'),
        $('#hpsfinder-modal'),
      );
    };

    if ($('#packstationfinder').length) {
      $('#packstationfinder').data('finder', Finder.packstation());
    }
    if ($('#postfilialefinder').length) {
      $('#postfilialefinder').data('finder', Finder.postfiliale());
    }
    if ($('#hpsfinder').length) {
      $('#hpsfinder').data('finder', Finder.hermespaketshop());
    }
  })(jQuery);
}
